<template>
    <div class="payrollSetting customerBox" ref="payrollSetting">
      <div class="payrollBox" v-loading="loading" style="min-height: 60vh;">
        <el-tabs v-model="payrollIndex"
          type="card"
          editable
          @edit="handleTabsEdit"
        >
          <el-tab-pane lazy="true"
            :key="item.name"
            v-for="(item, index) in payrollLists"
            :label="item.title"
            :name="item.name"
          >
            <wagesSettings :idx="index" :wages-from.sync="item.datas.wagesFrom" :item-lists.sync="item.datas.itemLists" @changeName="changeName"></wagesSettings>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
</template>

<script>
 /* import paySequence from "./paySequence"*/
  import wagesSettings from "./wagesSettings"
 import {getPayrollData,savePayrollDatas,getPayrollDataNull,deletePayroll} from  "@/api/wage/salaryTemplate";
 import { deepCopy } from "@/util/util";

  export default {
    name: "payrollSetting",
    components:{wagesSettings},
    created(){
        this._getPayrollData();
        this._getPayrollDataNull();
    },
    data(){
      return{
        payrollIndex: '0',
        payrollLists: [],
        tabIndex: 0,
        zIndex:499,
        itemLists:[],
				loading:false,
        firstLoad:true
      }
    },
    updated(){
      if(this.firstLoad){
        // this.firstLoad = false;
        setTimeout(() => {
            for(var i=0;i<this.payrollLists.length;i++){
                let dom = document.getElementById('tab-'+this.payrollLists[i].name);
                dom.style.left=-(i*20)+'px';
                dom.style.zIndex=--this.zIndex;
              };
        }, 100);
      }

    },
    methods: {
      handleTabsEdit(targetName, action) {
        if (action === 'add') {
          let left = this.payrollLists.length*(-20)

          let newTabName = (this.payrollLists.length) + Math.random();
          let lists = deepCopy(this.itemLists)
          this.payrollLists.push({
            title: '未命名-工资单模板',
            name: newTabName,
            datas:{
              wagesFrom:{},
              itemLists: lists,
            }
          });
          this.payrollIndex = newTabName;
          setTimeout(() => {
              let dom = document.getElementById('tab-'+newTabName);
              dom.style.left=left+'px';
              dom.style.zIndex=--this.zIndex;
              let transform = document.getElementsByClassName('el-tabs__nav')[0].style.transform;
              let index = transform.indexOf('-')+1;
							console.log(transform,2222222222222222)
              let Num = parseInt(transform.substr(index,transform.length));
              if((Num+left)>0){
                   document.getElementsByClassName('el-tabs__nav')[0].style.transform = 'translateX('+(-(Num+left))+'px)';
              }
          });
        }
        console.log(this.payrollLists,targetName,2222222222222222222222)

        if (action === 'remove') {
          let payrollTemp = {};
          for (let i in this.payrollLists) {
            let payroll = this.payrollLists[i];
            if(payroll.name == targetName){
              payrollTemp = deepCopy(payroll);//获取点击卡页
              break;
            }
          }
          this.$confirm("将要删除该工资单<"+payrollTemp.title+">, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            let id = payrollTemp.id;
            if(payrollTemp.id){
              deletePayroll(id).then(res=>{
                let r = res.data.data;
                if(r){
                  this.$message.success('删除成功')

                  let tabs = this.payrollLists;
                  let activeName = this.payrollIndex;
                  if (activeName === targetName) {
                    tabs.forEach((tab, index) => {
                      if (tab.name === targetName) {
                        let nextTab = tabs[index + 1] || tabs[index - 1];
                        if (nextTab) {
                          activeName = nextTab.name;
                        }
                      }
                    });
                  }
                  this.payrollIndex = activeName;
                  this.payrollLists = tabs.filter(tab => tab.name !== targetName);
                }
              })
            }else{
              let tabs = this.payrollLists;
              let activeName = this.payrollIndex;
              if (activeName === targetName) {
                tabs.forEach((tab, index) => {
                  if (tab.name === targetName) {
                    let nextTab = tabs[index + 1] || tabs[index - 1];
                    if (nextTab) {
                      activeName = nextTab.name;
                    }
                  }
                });
              }
              this.payrollIndex = activeName;
              this.payrollLists = tabs.filter(tab => tab.name !== targetName);
            }

          }).catch(()=>{

          });

        }
      },
      changeName([newName,idx]){
        this.loading = true;
        this.$set(this.payrollLists[idx],"title",newName)
        this.$set(this.payrollLists[idx],"name",newName)
        this.payrollIndex = newName;
        console.log("payrollLists----------",this.payrollLists[idx].datas);
        savePayrollDatas(this.payrollLists[idx].datas).then(res=>{
          this.loading = false;
          let rs=res.data;
          if(rs.code==0){
            this.$message.success('保存成功')
            this._getPayrollData();
          }else{
            this.$message.error('获取薪资项出现问题')
          }
        })
        this.$forceUpdate();
      },
      //获取工资单数据
      _getPayrollData(){
				this.loading = true;
        getPayrollData().then(res=>{
          let rs=res.data;
          if(rs.code==0){
            console.log("getPayrollData====",res.data.data);
            this.payrollLists = res.data.data?res.data.data:[];
            this.payrollIndex = '0';

          }else{
            this.$message.error('获取工资单数据出现问题')
          }
					this.loading = false;
        })
      },
      //获取薪资项选择数据
      _getPayrollDataNull(){
        getPayrollDataNull().then(res=>{
          let rs=res.data;
          if(rs.code==0){
              console.log("getPayrollDataNull====",res.data.data);
            this.itemLists = res.data.data;
          }else{
            this.$message.error('获取薪资项出现问题')
          }
        })
      },
    }
  };
</script>

<style scoped>
.customerBox >>> .el-tabs__nav-scroll{
    background: none;
}
.customerBox >>> .el-tabs__new-tab {
	position: relative;
	top: -6px;
  border: 1px solid #72B5E1 ;
  background: #72B5E1 ;
  height: 20px;
  width: 20px;
  line-height: 20px;

}
.customerBox >>> .el-tabs__new-tab>>>.el-icon-plus{
  font-weight: 600;
  color: #fff;
  transform: scale(1.2,1.2) !important;
}
.customerBox >>>.el-tabs__new-tab:hover {
  color: #fff;
}

</style>
<style>
  .el-tabs__new-tab .el-icon-plus {
    -webkit-transform: scale(1,1);
    transform: scale(1,1);
  }
  .el-tabs__new-tab .el-icon-plus:hover{
    -webkit-transform: scale(1.2,1.2);
    transform: scale(1.2,1.2) ;
  }
</style>

